import React from 'react';

export const RoomContext = React.createContext({
    onBackgroundTextureLoaded: null,
    roomId: null
});
